import React, { useRef, useEffect } from "react";
import "./Videos.scss";
import video1 from "../../assets/videos/video1.jpg";
import play from "../../assets/videos/play.png";
import Player from "@vimeo/player";

function Video1() {
  const poster = useRef();
  const video = useRef();

  const handleClickVideo = () => {
    poster.current.style.visibility = "hidden";
    video.current.play();
  };

  useEffect(() => {
    video.current = new Player("video1", {
      id: 376857392,
      controls: true,
      frameborder: "0",
      allow: "fullscreen; picture-in-picture",
      responsive: true,
    });
  }, []);

  useEffect(() => {
    video.current.on("ended", () => {
      poster.current.style.visibility = "visible";
    });
  });

  return (
    <section className="videos videos1">
      <div className="videos__video">
        <div className="videos1__poster" ref={poster}>
          <img src={video1} alt="" className="videos1__poster__img" />
          <img
            src={play}
            alt="play"
            className="videos__play"
            onClick={handleClickVideo}
          />
        </div>
        <div data-vimeo-id="376857392" id="video1" className="video" />
        {/* <iframe
          src="https://player.vimeo.com/video/376857392?h=009e3ef3b1&color=b89544&title=0&byline=0&portrait=0"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Inspired By Beauty"
          className="video"
          ref={video}
        ></iframe> */}
      </div>

      <p className="videos__video__title">INSPIRED BY BEAUTY</p>
      <p className="videos__video__copy">
        As a self-styled ‘beauty explorer,’ Roberto asserts that the most
        important experiences of beauty cannot be seen or even touched, they
        must be felt with the heart. That sentiment imbues every piece of
        jewelry he creates.
      </p>
    </section>
  );
}

export default Video1;
